<template>
    <div class="page-title">
        <div class="title">
            <h3>Follow-up Reminder</h3>
        </div>
    </div>

    <div class="card mb-3">
        <div class="card-body">
            <el-alert
                title="The assigned agent gets a phone notification this many minutes before the follow-up time set on Status Update."
                type="info"
                :closable="false"
                show-icon
                class="mb-3"
            />

            <el-form label-position="top" v-loading="loading">
                <el-form-item label="Minutes before follow-up">
                    <el-input-number
                        v-model="minutesBefore"
                        :min="1"
                        :max="180"
                        :precision="0"
                        :step="1"
                        controls-position="right"
                    />
                </el-form-item>

                <el-button type="primary" :loading="saving" @click="save">
                    Save
                </el-button>
            </el-form>
        </div>
    </div>

    <div class="card">
        <div class="card-header">
            <strong>Send log</strong>
        </div>
        <div class="card-body p-0">
            <el-table :data="logs" stripe v-loading="loading" empty-text="No reminders sent yet">
                <el-table-column prop="sent_at" label="Sent at" width="190" />
                <el-table-column label="Enquiry" width="160">
                    <template #default="{ row }">
                        #{{ row.enquiry_id }}
                        <div v-if="row.customer_name">{{ row.customer_name }}</div>
                    </template>
                </el-table-column>
                <el-table-column prop="agent_name" label="Agent" width="140" />
                <el-table-column prop="phone" label="Phone" width="120" />
                <el-table-column prop="follow_up_at" label="Follow-up time" width="180" />
                <el-table-column prop="message" label="Message" min-width="280" show-overflow-tooltip />
                <el-table-column label="Status" width="110">
                    <template #default="{ row }">
                        <el-tag :type="row.status === 'success' ? 'success' : 'danger'" size="small">
                            {{ row.status }}
                        </el-tag>
                    </template>
                </el-table-column>
                <el-table-column prop="response" label="API response" min-width="240" show-overflow-tooltip />
            </el-table>
        </div>
    </div>
</template>

<script>
import { ref, onMounted } from 'vue';
import { ElMessage } from 'element-plus';
import axios from 'axios';

export default {
    name: 'FollowupReminderSettings',
    setup() {
        const loading = ref(false);
        const saving = ref(false);
        const minutesBefore = ref(10);
        const logs = ref([]);

        const load = () => {
            loading.value = true;
            axios.get('/settings/followup-reminder/data')
                .then((res) => {
                    minutesBefore.value = Number(res.data.minutes_before || 10);
                    logs.value = res.data.logs || [];
                })
                .catch((err) => {
                    ElMessage.error(err?.response?.data?.message || 'Failed to load settings');
                })
                .finally(() => {
                    loading.value = false;
                });
        };

        const save = () => {
            const minutes = Number(minutesBefore.value);
            if (!Number.isInteger(minutes) || minutes < 1 || minutes > 180) {
                ElMessage.error('Enter a whole number from 1 to 180.');
                return;
            }

            saving.value = true;
            axios.post('/settings/followup-reminder', { minutes_before: minutes })
                .then((res) => {
                    minutesBefore.value = Number(res.data.minutes_before || minutes);
                    logs.value = res.data.logs || logs.value;
                    ElMessage.success(res.data.message || 'Saved');
                })
                .catch((err) => {
                    const msg = err?.response?.data?.message
                        || (err?.response?.data?.errors
                            ? Object.values(err.response.data.errors).flat().join(' ')
                            : 'Save failed');
                    ElMessage.error(msg);
                })
                .finally(() => {
                    saving.value = false;
                });
        };

        onMounted(load);

        return {
            loading,
            saving,
            minutesBefore,
            logs,
            save,
        };
    },
};
</script>
